import React, { Component } from 'react'
import Search from '@material-ui/icons/Search'
import AssignmentInd from '@material-ui/icons/AssignmentInd'
import InfoIcon from '@material-ui/icons/Info';
import NearMeRoundedIcon from '@material-ui/icons/NearMeRounded'

import '../../dummydata/style.css';


class TextSection extends Component {
    constructor(props){
        super(props)
    }

    render(){
        var icon;
        var style={margin:'0px'};
        var text;
        if(this.props.type == 'SCIENCE' || this.props.type == 'SCIENCE TEXT'){
            icon = <InfoIcon style={{fontSize:'1.6rem'}}/>
            text = <h3 style={{marginTop:"0px", listStylePosition:'inside'}} dangerouslySetInnerHTML={{__html: this.props.text}}></h3>
        }
        if(this.props.type == 'ACTION' || this.props.type == 'CALL TO ACTION'){
            icon = <NearMeRoundedIcon style={{color:'white', backgroundColor:'black', borderRadius:'50%', padding:'2px', fontSize:'1.3rem'}}/>
            text = <h3 style={{marginTop:"0px", listStylePosition:'inside'}} dangerouslySetInnerHTML={{__html: this.props.text}}></h3>
        }
        if(this.props.type == "RISK"){
            console.log("risk type")
            text = <h3 style={{marginTop:"0px", fontSize:'1.5em', listStylePosition:'inside'}} dangerouslySetInnerHTML={{__html: this.props.text}}></h3>
        }
        return(
            <div style={{margin:'30px 0 8px 0'}}>
                {icon}
                {text}
            </div>
            
        )
    }
}

export default TextSection;